import { render, staticRenderFns } from "./ListEmojis.vue?vue&type=template&id=d82aa4b4&scoped=true"
import script from "./ListEmojis.vue?vue&type=script&lang=js"
export * from "./ListEmojis.vue?vue&type=script&lang=js"
import style0 from "./ListEmojis.vue?vue&type=style&index=0&id=d82aa4b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d82aa4b4",
  null
  
)

export default component.exports